import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { getLastDayOfMonth } from "../utils/date";
import { localeUtils } from "../utils/date/locale";
export var TAB_TYPE = {
  month: 'month',
  range: 'range',
  empty: 'empty'
};

var getYear = function getYear() {
  return new Date().getFullYear();
};

var toDateString = function toDateString(year, month, day) {
  return new Date(year, month, day).toLocaleDateString('ru-RU');
};

export var transformStringDate = function transformStringDate() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return str.split('.').reverse().join('/');
};
export var getTabTypeByValue = function getTabTypeByValue(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      start = _ref2[0],
      end = _ref2[1];

  var _start$split = start.split('.'),
      _start$split2 = _slicedToArray(_start$split, 3),
      startDate = _start$split2[0],
      startMonth = _start$split2[1],
      startYear = _start$split2[2];

  var _end$split = end.split('.'),
      _end$split2 = _slicedToArray(_end$split, 3),
      endDate = _end$split2[0],
      endMonth = _end$split2[1],
      endYear = _end$split2[2];

  if (startMonth === endMonth && startYear === endYear) {
    var lastDayOfMonth = getLastDayOfMonth(Number(startMonth), +startYear);
    if (Number(endDate) === lastDayOfMonth && Number(startDate) === 1) return TAB_TYPE.month;
    return TAB_TYPE.range;
  }

  return TAB_TYPE.range;
};
export var changeYear = function changeYear(date, year) {
  var newDate = new Date(date);
  newDate.setFullYear(+year);
  return newDate;
};
export var monthToDates = function monthToDates(month) {
  var year = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getYear();
  var lastAllowedDay = arguments.length > 2 ? arguments[2] : undefined;
  var lastDayOfMonth = lastAllowedDay || getLastDayOfMonth(month + 1, year);
  var start = toDateString(year, month, 1);
  var end = toDateString(year, month, lastDayOfMonth !== null && lastDayOfMonth !== void 0 ? lastDayOfMonth : 2);
  return [start, end];
};
export var datesToMonth = function datesToMonth(_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
      start = _ref4[0],
      end = _ref4[1];

  if (!(start && end && start.startsWith('01'))) {
    return null;
  }

  var startYear = start.slice(6, 10);
  var endYear = end.slice(6, 10);

  if (startYear !== endYear) {
    return null;
  }

  var month = parseInt(start.slice(3, 5), 10);
  var lastDayOfMonth = getLastDayOfMonth(month, +endYear);

  if (lastDayOfMonth && end.startsWith(lastDayOfMonth.toString())) {
    return new Date(+endYear, month - 1, 2);
  }

  return null;
};
export var getTitle = function getTitle(_ref5) {
  var start = _ref5.start,
      end = _ref5.end,
      _ref5$title = _ref5.title,
      title = _ref5$title === void 0 ? '' : _ref5$title,
      locale = _ref5.locale;

  if (!start || !end) {
    return title;
  }

  var dateStart = new Date(transformStringDate(start));
  var dateEnd = new Date(transformStringDate(end));

  if (getTabTypeByValue([start, end]) === TAB_TYPE.range) {
    return "".concat(localeUtils.formatDayMonthShortYear(dateStart, locale), " - ").concat(localeUtils.formatDayMonthShortYear(dateEnd, locale));
  }

  return localeUtils.formatMonthTitle(dateStart, locale);
};
export var getLastAllowedDay = function getLastAllowedDay(dayTs) {
  return new Date(dayTs).getDate();
};
export var isLastDateInRange = function isLastDateInRange() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return value && value.length > 1 && Boolean(value[value.length - 1]);
};